module.exports = __webpack_public_path__ + "img/TSY_04.64680e63.jpg";